<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
        <article class="blog-article">
          <header class="blog-article__header">
            <div class="blog-article__meta">
              <p v-if="tagTitle" class="blog-article__meta-item blog-article__meta-tag">{{ tagTitle }}</p>
              <p class="blog-article__meta-item blog-article__meta-date">{{ formattedDate() }}</p>
            </div>
            <h1 class="blog-article__title">{{ title }}</h1>
            <p v-if="authorName" class="blog-article__author">By {{ authorName }}</p>
          </header>
          <div class="article__content">
            <component
                :is="getBodyModule(bodyModule.contentType)"
                v-for="(bodyModule, index) in body"
                :key="index"
                v-bind="bodyModule"
                class="blog-article__module"
            />
          </div>
        </article>
        <no-ssr>
          <share-page :title="title" :label="shareButtonText" />
        </no-ssr>
      </div>
    </div>
  </div>
</template>

<script>
import Moment from 'moment';
import ArticleBody from '~/components/components/ArticleBody';
import ArticleImage from '~/components/components/ArticleImage';
import ArticleVideo from '~/components/components/ArticleVideo';
import ArticleQuote from '~/components/components/ArticleQuote';
import SharePage from '~/components/components/SharePage';

export default {
  components: {
    ArticleBody,
    ArticleImage,
    ArticleVideo,
    ArticleQuote,
    SharePage,
  },
  props: {
    author: {
      type: Object,
      required: true,
      default() {
        return {
          name: 'Alyssa James',
        };
      },
    },
    date: { type: String, default: '2019-01-28T00:00:00Z', required: true },
    tag: {
      type: Object,
      default() {
        return {};
      },
    },
    title: { type: String, default: 'Test blog post', required: true },
    body: {
      type: Array,
      default() {
        return [
          {
            contentType: 'blog_post___body',
            body:
              '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce felis eros, ultrices sit amet auctor id, condimentum in nisi. Sed molestie neque id tincidunt finibus. Sed mollis aliquet dui. Aenean sit amet lorem eu odio fringilla porttitor a posuere turpis. Donec vehicula risus sit amet mi mattis, consequat luctus odio semper. Suspendisse faucibus dui eros, sed ultricies ipsum interdum ut. Quisque dignissim pellentesque ligula, eu malesuada nisi pellentesque eget. Nam egestas, urna non dignissim dictum, ipsum ante suscipit arcu, non lobortis enim ipsum non augue. Cras tortor velit, iaculis et quam sit amet, mollis finibus tortor. Maecenas facilisis hendrerit mi a malesuada. Suspendisse venenatis leo non arcu pharetra ullamcorper. Suspendisse in eleifend dolor. Donec suscipit mauris vel convallis consectetur. Interdum et malesuada fames ac ante ipsum primis in faucibus.</p><p>Vivamus accumsan in leo nec ultricies. Sed sodales, leo quis mollis pretium, mauris nisi ultricies urna, a vehicula urna diam ac tellus. Vestibulum lorem massa, aliquam ac orci eu, eleifend sodales lectus. Pellentesque volutpat luctus ligula, id suscipit leo auctor vitae. Curabitur in nunc augue. Nullam sodales maximus dui, vel scelerisque arcu finibus vel. Integer felis ex, vestibulum eget ornare sed, molestie eu sapien. Pellentesque eget porta nisl, at pharetra dolor.</p>',
          },
          {
            contentType: 'blog_post___image',
            caption: 'This is an image caption',
            image: {
              url: 'https://source.unsplash.com/X4RJG4aNi8o/900x500',
              description: 'This is an image caption',
            },
          },
          {
            contentType: 'blog_post___quote',
            body:
              '<p>I think jewellery is about the meaning you give to it rather than what it cost or where you bought it.</p>',
          },
          {
            contentType: 'blog_post___body',
            body:
              '<p>Vivamus accumsan in leo nec ultricies. Sed sodales, leo quis mollis pretium, mauris nisi ultricies urna, a vehicula urna diam ac tellus. Vestibulum lorem massa, aliquam ac orci</p><ul><li>Lorem ipsum</li><li>Lorem ipsum</li><li>Lorem ipsum</li><li>Lorem ipsum</li><li>Lorem ipsum</li></ul>',
          },
          {
            contentType: 'blog_post___video',
            source: 'youtube',
            sourceId: 'bfAOoSJxyQY',
          },
          {
            contentType: 'blog_post___body',
            body:
              '<h2>This is a sub title with body copy</h2><p>Vivamus accumsan in leo nec ultricies. Sed sodales, leo quis mollis pretium, mauris nisi ultricies urna, a vehicula urna diam ac tellus. Vestibulum lorem massa, aliquam ac orci eu, eleifend sodales lectus. Pellentesque volutpat luctus ligula, id suscipit leo auctor vitae. Curabitur in nunc augue. Nullam sodales maximus dui, vel scelerisque arcu finibus vel. Integer felis ex, vestibulum eget ornare sed, molestie eu sapien. Pellentesque eget porta nisl, at pharetra dolor.</p>',
          },
        ];
      },
      required: true,
    },
    shareButtonText: { type: String, default: 'Share Article' },
  },
  computed: {
    authorName() {
      return this.author.name;
    },
    tagTitle() {
      return this.tag.title;
    },
  },
  methods: {
    formattedDate() {
      if (!this.momentDate && this.date.length > 0) {
        this.momentDate = Moment(this.date);
      }

      if (this.date.length > 0) {
        return this.momentDate.format('Do MMM Y');
      }

      return '';
    },
    getBodyModule(contentType) {
      switch (contentType) {
        case 'blog_post___body': {
          return ArticleBody;
        }
        case 'blog_post___image': {
          return ArticleImage;
        }
        case 'blog_post___video': {
          return ArticleVideo;
        }
        case 'blog_post___quote': {
          return ArticleQuote;
        }
        default:
          return null;
      }
    },
  },
};
</script>

<style lang="scss">
@import '~/assets/scss/atomic/modules/_blog-article.scss';
</style>
